<script setup>
/**
 * Import packages
 */
import { defineComponent } from 'vue';

/**
 * Component Name
 */
defineComponent({
  name: 'VTableCol',
});
</script>

<template>
  <div class="v-table-col">
    <slot />
  </div>
</template>
